import React, { useEffect, useState } from "react";
import { RiCheckDoubleLine } from "react-icons/ri";
import { IoClose, IoImagesOutline } from "react-icons/io5";
import { LuBadgeInfo, LuSearch } from "react-icons/lu";
import { FaAngleLeft } from "react-icons/fa";
import { FaCirclePlus } from "react-icons/fa6";
import flag_2 from "./../../assets/img/tarh-parcham-iran-psdtarh2.png";
import { ApiEndpoints, useApiCall } from "../../api";
import MainLayout from "../../layout/main";
import { appRoutes, useAppNavigation } from "../../router/routes";
import { jalaliMonth, toDateString } from "../../helper/dateHelper";
import { useTableDataGenerator } from "../../helper/common";
import Loading from "../../component/loading";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import moment from "moment-jalali";
import { SelectOption } from "../../component/selectOption";
import { FiLock } from "react-icons/fi";
import { RoleViewSelector } from "../../component/roleViewSelector";
import { UserRoles } from "../../storage/enums";
import { Table } from "../../component/table";
import { useAlert } from "react-alert";
import { useValidation, ValidationTypes } from "../../helper/validation";
import { Input } from "../../component/input";

const handleScrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};

const ProgramAddPage = () => {
  const { navigate, queryParameter } = useAppNavigation();

  useEffect(() => {
    handleScrollToTop();
  }, []);
  const [selectedEvent, setSelectedEvent] = useState(false);

  const [[eventList], { loading: eventLoading }] = useApiCall({
    endpoints: ApiEndpoints.events.list,
  });

  const [implementationDate, setImplementationDate] = useState("");
  const [isPredict, setIsPredict] = useState(false);
  const [presenter, setPresenter] = useState(null);
  const [description, setDescription] = useState("");
  const [subject, setSubject] = useState([]);
  const [program, setProgram] = useState(null);
  const [selectedDay, setSelectedDay] = useState(null);
  const [reportDescription, setReportDescription] = useState("");

  const [[programTypeList, subjectList, activityList, programNameList]] =
    useApiCall({
      endpoints: [
        ApiEndpoints.docs.programTypeList,
        ApiEndpoints.docs.subjectList,
        ApiEndpoints.docs.activityList,
        ApiEndpoints.docs.programNameList,
      ],
    });

  const [, { loading: createProgramLoading, fetch: createProgram }] =
    useApiCall({
      endpoints: ApiEndpoints.program.create,
      lazy: true,
    });

  // بررسی می‌کنیم که آیا نوع برنامه‌ی انتخاب شده "تبیینی" است یا خیر؟
  const selectedProgramType = programTypeList?.data?.find(
    (c) => c.id === program?.barname_type
  );
  const isTabiini = selectedProgramType?.title === "تبیینی";

  const { errors, validate, removeError } = useValidation([
    {
      name: "selectedEvent",
      label: "مناسبت",
      value: selectedEvent ? String(selectedEvent.id) : "",
      validations: [
        {
          type: ValidationTypes.stringRequired,
          message: "لطفاً ابتدا یک مناسبت را انتخاب کنید",
        },
      ],
    },
    {
      name: "program",
      label: "عنوان برنامه",
      value: program,
      validations: [
        {
          type: ValidationTypes.objectRequired,
        },
      ],
    },
    {
      name: "subject",
      label: "موضوع تبیینی",
      value: subject,
      // اعمال اعتبارسنجیِ هوشمند فقط برای برنامه‌های تبیینی
      validations: isTabiini ? [
        {
          type: ValidationTypes.arrayMaxLength,
          options: { length: 3 },
        },
        {
          type: ValidationTypes.arrayMinLength,
          options: { length: 1 },
          message: "برای برنامه‌های تبیینی، حداقل یک موضوع باید انتخاب شود",
        },
      ] : [
        {
          type: ValidationTypes.arrayMaxLength,
          options: { length: 3 },
        }
      ],
    },
    {
      name: "implementationDate",
      label: "تاریخ اجرا",
      value: implementationDate,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
      ],
    },
    {
      name: "description",
      label: "جزئیات برنامه پیش بینی شده",
      value: description,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
        {
          type: ValidationTypes.stringMaxLength,
          options: {
            length: 80,
          },
        },
        {
          type: ValidationTypes.stringMinLength,
          options: {
            length: 5,
          },
        },
      ],
    },
    {
      name: "presenter",
      label: "مجری برنامه",
      value: presenter,
      validations: [
        {
          type: ValidationTypes.stringRequired,
        },
        {
          type: ValidationTypes.stringMaxLength,
          options: {
            length: 30,
          },
        },
        {
          type: ValidationTypes.stringMinLength,
          options: {
            length: 5,
          },
        },
      ],
    },
  ]);

  const [search, setSearch] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const { data } = useTableDataGenerator(eventList?.data ?? [], {
    filters: {
      title: search,
      month: selectedMonth,
    },
    pageSize: 1000,
  });

  useEffect(() => {
    if (!eventLoading) {
      const eventId = queryParameter().get("eventId")?.toString();
      const event = eventList?.data?.find((c) => c.id.toString() === eventId);
      setSelectedEvent(event);
      event &&
        setSelectedDay({
          year: parseInt(moment(event.date).format("jYYYY")),
          month: parseInt(moment(event.date).add("d").format("jM")),
          day: parseInt(moment(event.date).add("d").format("jD")),
        });
    }
  }, [eventLoading]);

  const [showModal, setShowModal] = useState(false);
  const onChangeModal = () => {
    setShowModal(true);
  };
  const hideModal = () => {
    setShowModal(false);
  };

  const alert = useAlert();
  
  const submitForm = async () => {
    const { isValid } = validate();
    
    // یک لایه امنیتی اضافه برای جلوگیری از ارسال فرم خالی
    if (!selectedEvent?.id || !program?.id || !implementationDate) {
      return alert.error("لطفاً فیلدهای اجباری (مناسبت، عنوان برنامه و زمان اجرا) را پر کنید");
    }

    if (!isValid) {
      return alert.error("لطفا خطا های فرم را برطرف کنید");
    }

    // گرفتن تازه‌ترین دیتاها با کلیدهای اصلی تا مبدل API فرانت‌اَند کارش را درست انجام دهد
    const dynamicPayload = {
      implementationDate: implementationDate ? moment(implementationDate).format("YYYY-MM-DD") : "",
      presenter: presenter,
      eventId: selectedEvent?.id,
      description: description,
      programType: program?.id,
    };

    // اگر موضوعی انتخاب شده بود، آن را به لیست اضافه می‌کنیم. در غیر این صورت اصلاً ارسال نمی‌شود
    if (subject && subject.length > 0) {
      dynamicPayload.subjectList = subject.map((c) => c.id);
    }

    const [createProgramResult] = await createProgram(dynamicPayload);
    
    if (createProgramResult.isOk) {
      alert.success("برنامه با موفقیت ذخیره شد", {
        timeout: 7000,
      });
      if (!isPredict) {
        navigate(
          appRoutes.programEditReport(createProgramResult.data.program_id),
        );
      } else {
        navigate(appRoutes.programList({}));
      }
    }
  };
  
  const activeBox = false;

  const [, { fetch: fetchQuestion }] = useApiCall({
    endpoints: ApiEndpoints.program.questionList,
    lazy: true,
  });

  const [reportQuestions, setReportQuestions] = useState([]);
  const updateProgramQuestions = async ({ id }) => {
    const [questionResponse] = await fetchQuestion({
      programNameId: id,
    });

    if (questionResponse?.data) {
      setReportQuestions(
        questionResponse?.data?.map((c) => ({
          ...c,
          value: "",
        })),
      );
    }
  };

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        {/* sec1 */}
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative p-8">
          <img src={flag_2} className=" absolute left-0 top-0 md:h-32 h-24" />
          <div className="flex flex-col gap-8 justify-center items-center w-[60%] mx-auto">
            <div>
              <div className="md:text-3xl text-xl text-center font-bold mb-6">
                <span>ثبت </span>
                <span className=" text-greenblue">برنامه</span>
              </div>
              <p className=" text-center ">
                مناسبت :<span> {selectedEvent?.title} </span>
                <span className={"opacity-80 mx-2"}>|</span>
                تاریخ :
                <span>
                  {" "}
                  {toDateString(selectedEvent?.date, "jYYYY/jMM/jDD")}{" "}
                </span>
              </p>
            </div>
          </div>
        </div>
        {/* sec 2 */}
        <div className="w-full max-w-[900px] mx-auto bg-gray-200 bg-opacity-90 border-2 border-gray-300 rounded-xl md:p-8 p-4">
          <div className="flex justify-between items-start">
            <div className={"font-bold"}> اطلاعات برنامه پیش بینی شده:</div>
            <div className="flex flex-col items-end">
              <button
                className=" bg-yellow-600 text-white rounded-lg md:px-6 px-3 md:text-base text-sm py-2"
                onClick={onChangeModal}
              >
                {" "}
                تغییر مناسبت{" "}
              </button>
              {errors["selectedEvent"] && (
                <span className="text-red-500 text-xs mt-1">
                  {errors["selectedEvent"]}
                </span>
              )}
            </div>
          </div>
          {/* form */}
          <div className="grid md:grid-cols-2 grid-cols-1 gap-8 mt-6">
            <div className="form-field w-full relative">
              <SelectOption
                label={"عنوان برنامه"}
                value={program?.id}
                error={errors["program"]}
                options={programNameList?.data?.map((c) => ({
                  label: c.title,
                  value: c.id,
                }))}
                onChange={(e) => {
                  removeError("program");
                  setProgram(
                    programNameList?.data?.find((c) => c.id === e.value),
                  );
                  setSubject([]);
                  updateProgramQuestions(
                    programNameList?.data?.find((c) => c.id === e.value),
                  );
                }}
              />
            </div>
            <div className="form-field w-full relative">
              <SelectOption
                label={"حوزه فعالیت"}
                value={
                  activityList?.data?.find(
                    (c) => c.id === program?.hoze_faaliat,
                  )?.id
                }
                options={activityList?.data?.map((c) => ({
                  label: c.title,
                  value: c.id,
                }))}
                onChange={(e) => {
                  setProgram(
                    programNameList?.data?.find((c) => c.id === e.value),
                  );
                }}
                disabled={true}
              />
            </div>
            <div className="form-field w-full relative">
              <SelectOption
                label={"نوع برنامه"}
                value={
                  programTypeList?.data?.find(
                    (c) => c.id === program?.barname_type,
                  )?.id
                }
                options={programTypeList?.data?.map((c) => ({
                  label: c.title,
                  value: c.id,
                }))}
                onChange={(e) => {
                  setProgram(
                    programNameList?.data?.find((c) => c.id === e.value),
                  );
                }}
                disabled={true}
              />
            </div>
            <div className="form-field w-full relative">
              <SelectOption
                label={"موضوع تبیینی"}
                value={subject?.map((c) => c.id)}
                max={3}
                error={errors["subject"]}
                options={subjectList?.data
                  ?.filter((c) => c.barname_type === program?.barname_type)
                  ?.map((c) => ({
                    label: c.title,
                    value: c.id,
                  }))}
                onChange={(e) => {
                  removeError("subject");
                  setSubject(
                    subjectList?.data?.filter((c) =>
                      e.find((x) => x.value === c.id),
                    ),
                  );
                }}
                isMulti
                info={"حداقل ۱ و حداکثر ۳ مورد باید انتخاب شود"}
              />
            </div>
            <div className="form-field w-full relative">
              <span className=" px-3 text-[12px] right-2"> زمان اجرا </span>
              <div
                className={`rounded-lg p-4 border-[1px] bg-white border-gray-100 w-full text-sm pl-8 ${errors["implementationDate"] ? "date-picker-input-error" : ""}`}
              >
                <DatePicker
                  inputClassName={`date-picker-input cursor-pointer ${implementationDate ? "" : "opacity-0"}`}
                  className="text-white"
                  calendarSelectedDayClassName="text-red"
                  locale={"fa"}
                  value={selectedDay}
                  onChange={(date) => {
                    setSelectedDay(date);
                    const { day, month, year } = date;
                    setImplementationDate(
                      moment(`${year}/${month}/${day}`, "jYYYY/jM/jD").toDate(),
                    );
                    setIsPredict(
                      moment(
                        `${year}/${month}/${day}`,
                        "jYYYY/jM/jD",
                      ).toDate() > new Date(),
                    );
                    removeError("implementationDate");
                    removeError("selectedEvent");
                  }}
                  inputPlaceholder={"انتخاب زمان اجرا"}
                  minimumDate={
                    selectedEvent &&
                    (selectedEvent.date_limit_in_use_once_a_year
                      ? {
                          year: parseInt(
                            moment(selectedEvent?.date)
                              .add("d", -5)
                              .format("jYYYY"),
                          ),
                          month: parseInt(
                            moment(selectedEvent?.date)
                              .add("d", -5)
                              .format("jM"),
                          ),
                          day: parseInt(
                            moment(selectedEvent?.date)
                              .add("d", -5)
                              .format("jD"),
                          ),
                        }
                      : {
                          year: parseInt(
                            moment(selectedEvent?.date)
                              .add("d", -5)
                              .format("jYYYY"),
                          ),
                          month: parseInt(1),
                          day: parseInt(1),
                        })
                  }
                  maximumDate={
                    selectedEvent &&
                    (selectedEvent.date_limit_in_use_once_a_year
                      ? {
                          year: parseInt(
                            moment(selectedEvent?.date)
                              .add("d", 5)
                              .format("jYYYY"),
                          ),
                          month: parseInt(
                            moment(selectedEvent?.date)
                              .add("d", 5)
                              .format("jM"),
                          ),
                          day: parseInt(
                            moment(selectedEvent?.date)
                              .add("d", 5)
                              .format("jD"),
                          ),
                        }
                      : {
                          year: parseInt(
                            moment(selectedEvent?.date)
                              .add("d", 5)
                              .format("jYYYY"),
                          ),
                          month: parseInt(12),
                          day: parseInt(30),
                        })
                  }
                />
              </div>
              {errors["implementationDate"] && (
                <p className={"text-sm mt-2 text-red-600"}>
                  {errors["implementationDate"]}
                </p>
              )}
            </div>
            <div className="form-field w-full relative">
              <span className="px-3 text-[12px] right-2"> مجری برنامه </span>
              <Input
                type="text"
                placeholder="مجری برنامه"
                className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                error={errors["presenter"]}
                onChange={(e) => {
                  setPresenter(e);
                  removeError("presenter");
                }}
                maxLength={30}
              />
            </div>
          </div>
          <div className="mt-8">
            <div className="form-field w-full relative">
              <span className="px-3 text-[12px] right-2">
                جزئیات برنامه پیش بینی شده
              </span>
              <Input
                type="text"
                placeholder="جزئیات برنامه پیش بینی شده"
                error={errors["description"]}
                onChange={(e) => {
                  setDescription(e);
                  removeError("description");
                }}
                maxLength={80}
              />
              <span className="px-3 text-[12px] right-2">
                تعداد کاراکتر: {description.length} / 80
              </span>
            </div>
          </div>
          <div className="mt-8 flex justify-center">
            <a
              onClick={submitForm}
              className="md:w-[40%] w-full py-4 text-white bg-blue-500 flex justify-center gap-2 rounded-lg cursor-pointer"
            >
              <RiCheckDoubleLine size={24} />
              <span>ذخیره و ارسال برنامه</span>
              <Loading isLoading={createProgramLoading} />
            </a>
          </div>
        </div>

        {/* sec 4 */}
        <div className=" bg-green2 gap-4 max-w-[900px] w-full mx-auto rounded-lg p-4 py-2 flex items-center text-white">
          <LuBadgeInfo size={62} />
          <p className="text-sm">
            فعال محترم ؛ برنامه فوق به عنوان برنامه ی پیش بینی شده خواهد بود.
            بخش زیرین ( ثبت گزارش) بعد از تاریخ اجرای برنامه فعال و امکان ثبت
            گزارش خواهد داشت . در صورت تایید ناظر ، امتیاز گزارش برنامه، منظور
            خواهد شد. در صورت اجرا نشدن برنامه پیش بینی شده ، لطفا آن را حذف
            نمایید.
          </p>
        </div>

        <div
          className={`w-full max-w-[900px] mx-auto bg-gray-200 bg-opacity-90 border-2 border-gray-300 rounded-xl md:p-8 p-4 ${activeBox ? "opacity-100" : "opacity-40"} `}
        >
          <div className="flex justify-between items-start">
            <div className={"font-bold"}> اطلاعات عمومی گزارش / اجباری:</div>
            {!activeBox && (
              <div className="p-2 text-gray-500">
                <FiLock size={32} />
              </div>
            )}
          </div>
          {/* form */}
          <div className="md:grid grid-cols-5 space-y-3 gap-8 mt-6 items-start">
            <div className=" col-span-3">
              <div className="">
                <div className="form-field w-full relative">
                  <span className="px-3 text-[12px] right-2">
                    جزئیات اجرای گزارش
                  </span>
                  <textarea
                    type="text"
                    placeholder="جزئیات اجرای گزارش"
                    className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                    rows="5"
                    disabled
                    maxLength={1400}
                    minLength={100}
                    value={reportDescription}
                    onChange={(e) => {
                      setReportDescription(e.target.value);
                    }}
                  ></textarea>
                  <span className="px-3 text-[12px] right-2">
                    تعداد کاراکتر: {reportDescription?.length ?? 0} / 1400
                  </span>
                  <div className="form-field w-full relative">
                    <span className="px-3 text-[12px] right-2">
                      {" "}
                      تعداد فعالیت های اجرا شده{" "}
                    </span>

                    <input
                      type="text"
                      placeholder="تعداد فعالیت های اجرا شده"
                      className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                      disabled
                    />
                  </div>
                </div>
                <div className="relative mt-4">
                  <div className=" flex flex-col gap-1 justify-center items-center w-32 h-28 border-gray-300 border-dashed border-2 rounded-xl bg-gray-100">
                    <IoImagesOutline size={24} className="text-gray-400" />
                    <span className="text-sm"> افزودن تصویر </span>
                    <FaCirclePlus className=" text-green-500" size={20} />
                  </div>
                  <p className={"text-sm mt-2"}>
                    حداقل 1 و حداکثر 3 عکس با پسوند jpg یا jpeg و حجم حداکثر 1.5
                    مگابایت بارگیری شود.
                  </p>
                </div>
              </div>
            </div>
            <div className="md:col-span-2 col-span-1 border-2 border-gray-200 rounded-xl bg-gray-100 p-4 flex flex-col gap-4 ">
              {reportQuestions.map((c) => {
                return (
                  <div className="form-field w-full relative">
                    <span className=" absolute -top-[8px]  px-3 text-[12px] right-2">
                      {c.question}
                    </span>

                    <input
                      disabled
                      contentEditable={"false"}
                      type="text"
                      placeholder={c.question}
                      className=" rounded-lg p-4 border-[1.5px] border-gray-100 w-full text-sm pl-8"
                      value={c.value}
                      onChange={(e) =>
                        setReportQuestions((qa) =>
                          qa.map((q) => {
                            if (q.id === c.id) {
                              return {
                                ...q,
                                value: e.target.value,
                                isNew: true,
                              };
                            }
                            return q;
                          }),
                        )
                      }
                    />
                  </div>
                );
              })}
              <div className="text-right mt-4">
                امتیاز برنامه :<span> {program?.score} </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen fixed top-0 left-0 overflow-y-scroll`}
        >
          <div className="md:w-[1200px] w-[350px] max-h-[600px] rounded-xl overflow-y-scroll p-8 bg-white absolute top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%]">
            <div className=" text-center text-lg font-semibold mb-4">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500"
                onClick={hideModal}
              >
                <IoClose size={24} />
              </div>
              ویرایش مناسبت
            </div>
            <div className="flex md:flex-row flex-col gap-4 mt-4 mb-4">
              <div className="form-feild relative">
                <input
                  type="text"
                  placeholder="جستجو عنوان"
                  className=" rounded-lg p-2 pr-8 border-[1.5px] border-gray-100 w-full text-sm pl-12"
                  onChange={(e) => setSearch(e.target.value)}
                />
                <LuSearch
                  className="absolute right-2 top-[50%] text-gray-300 -translate-y-[50%]"
                  size={20}
                />
              </div>
              <div className="form-feild relative">
                <select
                  type="text"
                  placeholder="شماره یک"
                  className=" rounded-lg w-40 p-2 pr-8 border-[1.5px] border-gray-100 text-sm"
                  onChange={(e) => setSelectedMonth(e.target.value)}
                >
                  <option name="month" value="">
                    انتخاب نشده
                  </option>
                  {jalaliMonth.map((c) => (
                    <option name={"month"} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <Table
              containerClassName={"max-h-[600px] overflow-y-scroll"}
              data={data}
              header={[
                {
                  name: "ردیف",
                  width: 2,
                  render: (i) => i.rowIndex,
                },
                {
                  name: "عنوان مناسبت",
                  width: 4,
                  render: (i) => i.title,
                },
                {
                  name: "تاریخ مناسبت",
                  width: 3,
                  render: (i) => toDateString(i.date, "jYYYY/jMM/jDD"),
                },
                {
                  name: "عملیات",
                  width: 2,
                  render: (i) =>
                    i.id.toString() === selectedEvent?.id?.toString() ? (
                      "انتخاب شده"
                    ) : (
                      <button
                        onClick={() => {
                          setSelectedEvent(i);
                          setSelectedDay(null);
                          setImplementationDate("");
                          removeError("selectedEvent");
                          setShowModal(false);
                        }}
                        className="flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                      >
                        انتخاب
                        <FaAngleLeft />
                      </button>
                    ),
                },
              ]}
            />
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default ProgramAddPage;